<template>
  <div class="amount-range-input">
    <div class="amount-range-input__title" v-if="title">
      {{ title }}
    </div>
    <div class="amount-range-input__body">
      <base-text-input
        :mask="numberMaskOptions"
        class="amount-range-input__field"
        :placeholder="$t('amount-range-input.placeholder.from')"
        v-model:value="value.from"
        @enter="$emit('enter')"
      ></base-text-input>
      <div class="amount-range-input__delimiter">-</div>
      <base-text-input
        :mask="numberMaskOptions"
        class="amount-range-input__field"
        :placeholder="$t('amount-range-input.placeholder.to')"
        v-model:value="value.to"
        @enter="$emit('enter')"
      ></base-text-input>
    </div>
  </div>
</template>

<script>
// import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import BaseTextInput from '@vue-app/components/base/input/BaseTextInput.vue'

// const numberMask = createNumberMask({
//   prefix: '',
//   allowDecimal: true,
//   includeThousandsSeparator: false,
//   allowNegative: false,
//   decimalLimit: 2,
// })

export default {
  name: 'AmountRangeInput',
  components: { BaseTextInput },
  props: {
    value: {
      type: Object,
      default() {
        return {
          from: '0',
          to: '0',
        }
      },
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      numberMaskOptions: {
        mask: Number,
        radix: '.',
        scale: 2,
        signed: false,
        normalizeZeros: true,
        padFractionalZeros: false,
        mapToRadix: [','],
      },
    }
  },
  emits: ['enter', 'update:value', 'update:value'],
}
</script>

<style lang="scss" scoped>
.amount-range-input {
  &__title {
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    color: #909cb0;
    padding-left: 10px;
    margin-bottom: 5px;
  }

  &__body {
    display: flex;
    align-items: center;
  }

  &__field {
    width: 90px;
  }

  &__delimiter {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    margin-right: 5px;
  }
}
</style>
